import { useEffect } from 'react';
import { TFunction } from 'i18next';
import { Equipment } from '@/api/entities/equipment';
import { CheckPoint, CheckPointType } from '@/api/entities/check-point';
import { CheckpointGroup } from '@/api/entities/checkpointGroup';
import { GroupCheckPointManagement } from '../GroupCheckPointManagement';
import { GroupCheckPointEquipments } from '../GroupCheckPointEquipments';
import { EditGroupIdTab } from '@/type/ui/tab/groupTab';
import { TGroupSchema } from '@/schemas/group/group.schema';
import { FormManagementProps } from '@/type/form.types';

type GroupReportManagementProps = FormManagementProps<TGroupSchema> & {
  t?: TFunction<undefined>;
  isModerator?: boolean;
  checkPoints: CheckPoint[];
  equipments: Equipment[];
  checkpointGroup?: CheckpointGroup[];
};

export const GroupReportManagement = ({
  t,
  isModerator,
  checkPoints,
  equipments,
  checkpointGroup,
  data,
  watch,
  control,
  register,
  setValue,
  setError,
  errors,
  submitDisabled,
  onSubmit,
}: GroupReportManagementProps) => {
  const groupId = data?.id;

  // Scroll to the Equipments Per Inspection section
  useEffect(() => {
    if (
      window.location.hash === `#${EditGroupIdTab.EQUIPMENTS_PER_INSPECTION_ID}`
    ) {
      setTimeout(() => {
        const element = document.getElementById(
          EditGroupIdTab.EQUIPMENTS_PER_INSPECTION_ID,
        );
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="flex flex-col gap-7">
      {/* <GroupCheckPointManagement<TGroupSchema>
        t={t}
        checkPointType={CheckPointType.VIDEO}
        cardTitle={
          <div className="flex gap-2">
            <i className="ki-filled ki-youtube text-purple-500 text-[25px]" />
            <p>{t('common:checkPointVideos')}</p>
          </div>
        }
        blurLicensePlateField="blurVideoCheckPointLicensePlate"
        licensePlateImageField="videoCheckPointLicensePlateImage"
        backgroundImageField="videoCheckPointBackground"
        watermarkField="videoCheckPointWatermark"
        watermarkPositionField="videoCheckPointWatermarkPosition"
        data={data}
        control={control}
        register={register}
        setValue={setValue}
        watch={watch}
        setError={setError}
        errors={errors}
        submitDisabled={submitDisabled}
        mutate={onSubmit}
      /> */}
      {!isModerator && (
        <GroupCheckPointManagement<TGroupSchema>
          t={t}
          checkPointType={CheckPointType.PHOTO}
          cardTitle={
            <div className="flex gap-2">
              <i className="ki-filled ki-picture text-purple-500 text-[25px]" />
              <p>{t('common:checkPointPhotos')}</p>
            </div>
          }
          blurLicensePlateField="blurPhotoCheckPointLicensePlate"
          licensePlateImageField="photoCheckPointLicensePlateImage"
          backgroundImageField="photoCheckPointBackground"
          watermarkField="photoCheckPointWatermark"
          watermarkPositionField="photoCheckPointWatermarkPosition"
          data={data}
          control={control}
          register={register}
          setValue={setValue}
          watch={watch}
          setError={setError}
          errors={errors}
          submitDisabled={submitDisabled}
          mutate={onSubmit}
        />
      )}
      <div id={EditGroupIdTab.EQUIPMENTS_PER_INSPECTION_ID}>
        <GroupCheckPointEquipments
          t={t}
          checkPoints={checkPoints}
          equipments={equipments}
          checkpointGroup={checkpointGroup}
          groupId={groupId}
        />
      </div>
    </div>
  );
};
